import { AxiosRequestConfig } from 'axios';
import { AuthRepository } from 'infraestructure/repositories';

export const Authentication = (
  config: AxiosRequestConfig
): AxiosRequestConfig => {
  const repository = new AuthRepository();
  const token = repository.loadToken();

  const isInternalApi = !config.url?.startsWith('http');

  if (token && isInternalApi && config.headers) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }

  return config;
};

export default Authentication;
